import * as React from 'react';
import { observer } from 'mobx-react';
import './NotificationsContainer.pcss';
import {Notification} from "components/widgets/Notification/Notification";
import {CollapsedNotification} from "data/entities/INotification";
import * as theme from 'theme.js';
import {UIState} from "data/UIState";
import {useRef} from "react";
import {useClickOutside} from "components/widgets/useClickOutside";
import * as FocusTrap from "focus-trap-react";
import {handleSpacePressed} from "utils";

interface INotificationsContainerProps {
  delay:number;
  collapsedNotifications:CollapsedNotification[];
  onCollapsedNotificationNav:(collapsedNotification:CollapsedNotification)=>void;
  onDismissCollapsedNotification:(collapsedNotification:CollapsedNotification)=>void;
}

  export const NotificationsContainer: React.FC<INotificationsContainerProps> =
    observer(
      (
        {
          collapsedNotifications,
          onCollapsedNotificationNav,
          onDismissCollapsedNotification,
        }
      ) => {


    const ref = useRef<HTMLDivElement>(null)
    useClickOutside(ref, ()=>{
        UIState.closeNotifications();
      }
    );

    return (
      <FocusTrap focusTrapOptions={
        {
          allowOutsideClick: false,
          clickOutsideDeactivates: true,
          // onPostActivate:()=>{ console.log('Focus Trap onPostActivate') },
          // onActivate:()=>{ console.log('Focus Trap onActivate') },
          onDeactivate:()=>{ UIState.closeNotifications(); },
          // onPostDeactivate:()=>{ console.log('Focus Trap onPostDeactivate') },
          initialFocus: '#notifications-title',
          delayInitialFocus: true,

        }
      }>
      <div ref={ref} className="notifications-container">
        <div className={"notifications-header"}>
          <h3 id={"notifications-title"}>Notifications</h3>
          <button
            className="three-band-focus"
            onClick={() => {
              UIState.closeNotifications();
            }}
            onKeyDown={(e) => {
              handleSpacePressed(e, UIState.closeNotifications);
            }}
          ><span className="material-symbols-outlined">close</span></button>
        </div>
        {collapsedNotifications.length === 0 ? (
          <div className="no-current-notifications">
            No current notifications
          </div>
        ) : (
          <div className="notifications-list" role={"list"}>
            {collapsedNotifications.map((collapsedNotification: CollapsedNotification) => (
              <Notification
                key={collapsedNotification.id}
                collapsedNotification={collapsedNotification}
                onDismissCollapsedNotification={onDismissCollapsedNotification}
                onCollapsedNotificationNav={onCollapsedNotificationNav}
              />
            ))}
          </div>
        )}

        <div className={'pointer'} aria-hidden>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
            <path d="M7 0L13.9282 12H0.0717969L7 0Z" fill={theme.CloudGray}/>
          </svg>
        </div>
      </div>
      </FocusTrap>
    );
  });

